import React from "react";

import closeIcon from "static/images/close-icon.png";
import styles from "./modal.module.scss";
//TODO: this modal can be removed
const TidRequestViewModal = ({ onHide, show, tidView }) => {
	const getAgentNames = tidView => {
		return (
			tidView.agents &&
			tidView.agents
				.map(agent => `${agent.firstName} ${agent.lastName}`)
				.join(", ")
		);
	};
	return (
		<div className={styles.wrappBoardingView}>
			{show ? (
				<div className={styles.modal}>
					<div className={styles.modalContent}>
						<div className={styles.wrappCloseIcon}>
							<img src={closeIcon} alt="close" onClick={onHide} />
						</div>
						<div className={styles.wrappViewContent}>
							<p>MID:</p>
							<p className={styles.mid}>{tidView.mid}</p>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>Merchant:</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{tidView.merchantName}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>
									Processor / Sponsor:
								</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{tidView.processor} / {tidView.sponsor}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>
									Industry Type (MCC):
								</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{tidView.industryType}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>
									Agent Office:
								</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{tidView.agentOffice}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>Agent Name:</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{getAgentNames(tidView) || "House Account"}
								</p>
							</div>
						</div>
						<div className={styles.wrappViewContent}>
							<div className={styles.wrappViewHeader}>
								<p className={styles.viewHeader}>Status:</p>
							</div>
							<div className={styles.wrappViewData}>
								<p className={styles.viewData}>
									{tidView.tidStatus}
								</p>
							</div>
						</div>
					</div>
				</div>
			) : null}
		</div>
	);
};

export default TidRequestViewModal;
